//import BizMetrics from "../../models/BizMetrics";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: last
      });
    },

    async getReviewRequests(context, args) {
      let vueThis = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/biz-metrics/review-requests`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        const last30ReviewRequests = response.data.last30ReviewRequests;
        const lastReviewRequestDate = response.data.lastReviewRequestDate;
        vueThis.dispatch("entities/bizMetrics/insertOrUpdate", {
          data: [
            {
              id: "last30ReviewRequests",
              metricType: "last30ReviewRequests",
              metricValue: last30ReviewRequests
            },
            {
              id: "lastReviewRequestDate",
              metricType: "lastReviewRequestDate",
              metricValue: lastReviewRequestDate
            }
          ]
        });
        vueThis.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        vueThis.dispatch("entities/settings/setIsOffline", true);
      }
    },
    
    async getDailyReviewRequests(context, args) {
      let vueThis = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/biz-metrics/daily-review-requests`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        const requestHistory = response.data;
        vueThis.dispatch("entities/bizMetrics/insertOrUpdate", {
          data: [
            {
              id: "daily-review-requests",
              metricType: "daily-review-requests",
              metricValue: requestHistory
            }
          ]
        });
        vueThis.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        vueThis.dispatch("entities/settings/setIsOffline", true);
      }
    }
  }
}

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/biz-metrics?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let bizMetrics = [];
    obj.forEach(function(bizMetric) {
      bizMetrics.push({
        id: bizMetric.id,
        isDirty: false,
        accountId: bizMetric.accountId,
        // googlePlaceId: bizMetric.googlePlaceId,
        // facebookPageId: bizMetric.facebookPageId,
        // yelpPageId: bizMetric.yelpPageId,
        config: bizMetric.config,
        createdAt: Date.parse(bizMetric.createdAt),
        updatedAt: Date.parse(bizMetric.updatedAt)
      });
    });
    if (bizMetrics.length > 0) {
      store.dispatch("entities/bizMetrics/insert", {
        data: bizMetrics
      });
    }
    this.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    this.dispatch("entities/settings/setIsOffline", true);
  }
}
